
export function addSendMailToForm(formID, responseArea) {
    const form = document.querySelector('#' + formID);

    if (form) {
        form.addEventListener('submit', (e) => {
            e.preventDefault();

           if (checkCheckBox() == true) {
                sendMail(form)
                .then((res) => {
                    return res.json();
                }).then((data) => {
                    handleSubmissionResponse(data, responseArea, form);
                });
           }  else {
                let englishPage = window.location.href.endsWith('?lang=en');
                responseArea.innerHTML = englishPage ? "Please, authorize data treatment" : "E' necessario accettare i termini";
           }
        });
    }
}

const checkCheckBox = () => {
    let isChecked = false;
    let checkbox = document.querySelector('.mcl-checkbox input');
        if (checkbox.checked) {
            isChecked = true;
        } else {
            isChecked = false;
        }
    return isChecked;
}

const sendMail = (formElement) => {
    let formData = new FormData(formElement);

    return fetch(ajax.baseUrl, {
        method: 'POST',
        credentials: 'same-origin',
        body: formData
      })
      .then((res) => {
          return res;
      })
  }

  const handleSubmissionResponse = (response, responseArea, form) => {
    responseArea.innerHTML = '';

    if (!response || !response.success ) {
        let showError = '';
        (response.errors || []).forEach(error => {
            showError += error + '<br />';
        })
        responseArea.innerHTML = showError;
    } else {
        form.reset();
        let englishPage = window.location.href.endsWith('?lang=en');
        responseArea.innerHTML = englishPage ? 'Mail send correctly' : 'Mail inviata correttamente';
        responseArea.className += ' correct';
    }
  }



// WEBPACK FOOTER //
// ./src/layouts/general/sendMail.js